export const sortFilesWithNumbers = (files: string[]) => {
  const collator = new Intl.Collator(undefined, {
    numeric: true,
    sensitivity: 'base',
  });

  return files.sort(collator.compare);
};
